<div class="print-main-container">
  @for (sum of exesum?.sections; track sum) {
    <div class="print-section" >
      <p [innerHTML]="sum.title"></p>
      <p [innerHTML]="sum.desc" ></p>
    </div>
  }
</div>



